/* CP — Parallax fuer Kategorie-Banner. Ausgelagert aus cp-category.js. */
/* ---------- Parallax für den Banner (unabhängig von der Filterlogik) ----------
   Misst die Position des Banners direkt (getBoundingClientRect) statt window.scrollY,
   damit es auch funktioniert, wenn nicht das Fenster, sondern ein Container scrollt. */
(function(){
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var items = [], raf = 0, bound = false;

  // Nächster scrollender Vorfahre (Fallback: Fenster)
  function scrollerOf(el){
    var p = el.parentElement;
    while(p && p !== document.body && p !== document.documentElement){
      var cs = window.getComputedStyle(p);
      if(/(auto|scroll)/.test(cs.overflowY) && p.scrollHeight > p.clientHeight + 1) return p;
      p = p.parentElement;
    }
    return null;
  }
  function scrollTopOf(it){
    if(it.scroller) return it.scroller.scrollTop;
    return window.pageYOffset || (document.scrollingElement || document.documentElement).scrollTop || 0;
  }
  function viewH(it){
    return it.scroller ? it.scroller.clientHeight : (window.innerHeight || document.documentElement.clientHeight || 0);
  }

  function measure(it){
    var r = it.hero.getBoundingClientRect();
    var vh = viewH(it);
    it.h = r.height;
    it.restTop = r.top + scrollTopOf(it);                      // Position des Banners in Ruhelage
    it.start   = Math.max(0, it.restTop - vh);                 // ab hier ist der Banner im Bild
    it.max     = Math.round((it.restTop + it.h - it.start) * it.k);
    it.hero.style.setProperty('--cpk-px', it.max + 'px');
    it.y = -1;
  }

  function tick(){
    raf = 0;
    if(mq && mq.matches) return;
    for(var i=0;i<items.length;i++){
      var it = items[i];
      var r = it.hero.getBoundingClientRect();
      var vh = viewH(it);
      if(r.bottom <= 0 || r.top >= vh) continue;                // nicht im Bild
      var scrolled = it.restTop - r.top;                       // so weit ist der Banner nach oben gewandert
      var y = Math.max(0, Math.min(it.max, Math.round((scrolled - it.start) * it.k)));
      if(y === it.y) continue;
      it.y = y;
      it.img.style.transform = 'translate3d(0,' + y + 'px,0)';
    }
  }

  function schedule(){ if(!raf) raf = window.requestAnimationFrame(tick); }
  function remeasure(){ for(var i=0;i<items.length;i++) measure(items[i]); schedule(); }

  function setup(hero){
    if(hero.__cpkPx) return;
    var img = hero.querySelector('.cpk__heroimg');
    if(!img) return;
    var k = parseFloat(hero.getAttribute('data-cpk-parallax'));
    if(isNaN(k)) k = 30;
    var it = { hero:hero, img:img, k:Math.min(.8, Math.max(.05, k / 100)),
               scroller:scrollerOf(hero), h:0, restTop:0, start:0, max:0, y:-1 };
    hero.__cpkPx = it;
    items.push(it);
    measure(it);
    if(!img.complete) img.addEventListener('load', remeasure, { once:true });
    if(window.ResizeObserver){ new ResizeObserver(remeasure).observe(hero); }
    if(it.scroller) it.scroller.addEventListener('scroll', schedule, { passive:true });
    if(!bound){
      bound = true;
      window.addEventListener('scroll', schedule, { passive:true });
      document.addEventListener('scroll', schedule, { passive:true, capture:true });
      window.addEventListener('resize', remeasure);
      window.addEventListener('load', remeasure);
      if(mq && mq.addEventListener) mq.addEventListener('change', function(){
        for(var i=0;i<items.length;i++){ items[i].img.style.transform = ''; items[i].y = -1; }
        schedule();
      });
    }
    schedule();
  }

  function scan(root){
    var list = (root || document).querySelectorAll('[data-cpk-parallax]');
    for(var i=0;i<list.length;i++) setup(list[i]);
  }
  scan(document);
  // Theme-Editor lädt Sections neu
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  window.CPParallax = { items: items, refresh: remeasure };
})();
